// Shared formatting utilities

export function fmtMoney(n) {
  return '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function fmtMoneyShort(n) {
  return '$' + Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })
}

export function fmtDate(d) {
  return d ? new Date(d + (d.length === 10 ? 'T12:00:00' : '')).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '--'
}

export function fmtDateShort(d) {
  return d ? new Date(d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : '--'
}

export function fmtDateFull(d) {
  return d ? new Date(d + (d.length === 10 ? 'T12:00:00' : '')).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }) : '--'
}

export function fmtPct(n) {
  return Number(n || 0).toFixed(1) + '%'
}

export function toISO(d) {
  return d.toISOString().split('T')[0]
}

export function timeAgo(dateStr) {
  var now = new Date()
  var d = new Date(dateStr)
  var diff = Math.floor((now - d) / 1000)
  if (diff < 60) return 'just now'
  if (diff < 3600) return Math.floor(diff / 60) + 'm ago'
  if (diff < 86400) return Math.floor(diff / 3600) + 'h ago'
  if (diff < 604800) return Math.floor(diff / 86400) + 'd ago'
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export function weekStart(d) {
  const s = new Date(d)
  s.setDate(s.getDate() - s.getDay())
  s.setHours(0, 0, 0, 0)
  return s
}

export function weekEnd(d) {
  const e = weekStart(d)
  e.setDate(e.getDate() + 6)
  e.setHours(23, 59, 59, 999)
  return e
}
